export default __webpack_public_path__ + "static/media/MMC_Regular.df1bcf0b.woff";